import { TFunction } from 'client/i18n/hooks/useT';
// second representations of time

// todo: get a library for months, leap years, etc.
export const YEAR_SECS = 31536000; // not leap year
export const MONTH_SECS = 2628000; // rough estimate
export const WEEK_SECS = 604800;
export const DAY_SECS = 86400;
export const HR_SECS = 3600;
export const MIN_SECS = 60;

// For use with DOB select inputs
const currentYear = new Date().getFullYear();
export const yearOptions = Array.from({ length: 117 }, (_, i) => {
  const year = String(currentYear - i);
  return {
    label: year,
    value: year,
  };
});

export const dayOptions = Array.from({ length: 31 }, (_, i) => ({
  label: String(i + 1),
  value: (i + 1).toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false,
  }),
}));

export const getMonthOptions = (t: TFunction) => [
  {
    label: t('Month.January', 'January', 'January month text'),
    value: '01',
  },
  {
    label: t('Month.February', 'February', 'February month text'),
    value: '02',
  },
  {
    label: t('Month.March', 'March', 'March month text'),
    value: '03',
  },
  {
    label: t('Month.April', 'April', 'April month text'),
    value: '04',
  },
  {
    label: t('Month.May', 'May', 'May month text'),
    value: '05',
  },
  {
    label: t('Month.June', 'June', 'June month text'),
    value: '06',
  },
  {
    label: t('Month.July', 'July', 'July month text'),
    value: '07',
  },
  {
    label: t('Month.August', 'August', 'August month text'),
    value: '08',
  },
  {
    label: t('Month.September', 'September', 'September month text'),
    value: '09',
  },
  {
    label: t('Month.October', 'October', 'October month text'),
    value: '10',
  },
  {
    label: t('Month.November', 'November', 'November month text'),
    value: '11',
  },
  {
    label: t('Month.December', 'December', 'December month text'),
    value: '12',
  },
];
